module.exports = __webpack_public_path__ + "questto--29709dad.png";


//////////////////
// WEBPACK FOOTER
// ./_source/img/parceiros/questto.png
// module id = 241
// module chunks = 0